<template>
  <div
    class="claim-business-card"
    v-bind="$attrs"
  >
    <div class="container">
      <div class="image-container">
        <img
          v-if="validImage"
          :src="image"
          alt="Business Image"
          class="business-image"
        >
        <div
          v-else
          class="no-image-container"
        >
          <i class="bi bi-shop" />
        </div>
      </div>

      <div class="content">
        <h3 class="body--large">
          {{ title }}
        </h3>

        <p class="body--small">
          {{ address }}
        </p>
        <p class="body--small">
          {{ city }}, {{ state }} {{ zip }}
        </p>

        <p
          v-if="description"
          class="body--small"
        >
          {{ description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClaimBusinessCard",

  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    city: {
      type: String,
      default: ""
    },
    state: {
      type: String,
      default: ""
    },
    address: {
      type: String,
      default: ""
    },
    zip: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    badge: {
      type: String,
      default: ""
    },
    badgeClass: {
      type: String,
      default: ""
    },
    days: {
      type: Number,
      default: null
    }
  },

  computed: {
    validImage() {
      return Boolean(this.image && typeof this.image === "string" && this.image.trim() !== "");
    }
  }
};
</script>

<style lang="scss" scoped>
.claim-business-card {
  width: 100%;
  max-width: 100%;

  .container {
    border: 1px solid $color-neutral-light;
    border-radius: $radius-large;
    background-color: $color-white;
    cursor: default;
    @include stack-space($space-none);
  }

  .image-container {
    width: 100%;
    height: 120px;
    overflow: hidden;
    border-radius: $radius-large $radius-large 0 0;

    .business-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .no-image-container {
      width: 100%;
      height: 100%;
      background-color: $color-neutral-lightest;
      display: flex;
      justify-content: center;
      align-items: center;

      .bi-shop {
        font-size: $icon-large;
        color: $color-neutral-dark;
      }
    }
  }

  .content {
    @include inset-space($space-small);
    @include stack-space($space-xxsmall);
    text-align: left;

    h3,
    p {
      margin: 0;
    }
  }

  @media (min-width: #{$mobile-breakpoint-min-width + 1}) {
    .container {
      @include inline-space($space-none);
      align-items: stretch;
    }

    .image-container {
      width: 25%;
      min-height: 140px;
      height: auto;
      border-radius: $radius-large 0 0 $radius-large;
    }

    .content {
      flex: 1;
      @include inset-space($space-large);
    }
  }
}
</style>
